	// Select the wrapper-navbar element
	const wrapperNavbar = document.getElementById('main-nav');

	// Function to add the 'fixed' class on scroll
	function addFixedClassOnScroll() {
		if (window.scrollY > 0) {
			wrapperNavbar.classList.add('fixed');
		} else {
			wrapperNavbar.classList.remove('fixed');
		}
	}

	// Attach the scroll event listener
	window.addEventListener('scroll', addFixedClassOnScroll);


  document.addEventListener('DOMContentLoaded', () => {
		function handleResize() {
			if (window.innerWidth >= 1068) {
				const nav = document.querySelector('#wrapper-navbar');
				const stickyDiv = document.querySelector('.inner-page-nav-wrapper');
				const titleBar = document.querySelector('.title-wrapper');
				if (titleBar && stickyDiv) {
					const offset = titleBar.clientHeight + 12; // Add additional padding as needed

					window.addEventListener('scroll', () => {
						if (window.pageYOffset >= offset) {
							stickyDiv.classList.add('sticky-nav');
                            stickyDiv.style.top = nav + 'px';
							document.querySelector('.site-main').style.marginTop = stickyDiv.clientHeight + 'px';

						} else {
							stickyDiv.classList.remove('sticky-nav');
							document.querySelector('.site-main').style.marginTop = '0';
						}
					});
				}
			}
		}

		handleResize(); // Initial execution on page load

		window.addEventListener('resize', handleResize); // Execute on window resize
	});